import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useState, useEffect } from "react";
import { GlobalProvider } from "./GlobalContext";
import MainLayout from "./Components/MainLayout";
import SettingsPage from "./Components/Settings/SettingsPage";
import TeamsPage from "./Components/Teams/TeamsPage";
import DriversPage from "./Components/Driver/DriversPage";
import BankPage from "./Components/Banks/BankPage";
import TasksPage from "./Components/Tasks/TasksPage";
import ReportsPage from "./Components/Reports/ReportsPage";
import LoginPage from "./Components/Login/LoginPage";
import ShopsPage from "./Components/Shops/ShopsPage";
import { Toaster } from "react-hot-toast";
import "./App.css";
import SlotManager from "./Components/Gigs/SlotManager";
import TierSection from "./Components/Tier/Tier";
import Notification from "./Components/Notification/Notification";
import IntroScreen from "../src/Components/Utils/IntroScreen";
import DashboardContainer from "./Components/MainDashboard/DashboardContainer";
import Attendance from "./Components/Attendance/Attendance";
import Settlement from "./Components/Settlement/Settlement";
import SettlementDetail from "./Components/Settlement/SettlementDetail";
import DriverAnalytics from "./Components/Reports/DriverAnalytics";
import Admin from "./Components/Admin/Admin";

// import
import VolunteerLoginPage from "./Components/Login/VolunteerLoginPage";
import VolunteerAttendance from "./Components/Admin Volunteer/Attendance/VolunteerAttendance";
import VolunteerPage from "./Components/Admin Volunteer/Volunteer/VolunteerPage";
//  import VolunteerTeamPage from "./Components/Admin Volunteer/VolunteerTeam/VolunteerTeamPage";
import VolunteerLayout from "./Components/Admin Volunteer/Utils/VolunteerLayout";
import VolunteerShopsPage from "./Components/Admin Volunteer/Shops List/VolunteerShopsList";
import VolunteerProtected from "./Components/Admin Volunteer/Utils/volunteerProtected";
import VolunteersBank from "./Components/Admin Volunteer/Banks/VolunteersBank";
import AdminProtected from "./Components/Utils/AdminProtected";
import Store from "./Components/Store/Store";
import DriverOrdersPage from "./Components/Driver/DriverOrdersPage";
import VolunteerSettlement from "./Components/Admin Volunteer/Settlement/VolunteerSettlement";

function CatchAllRedirect() {
  const isAdminAuthenticated = !!sessionStorage.getItem("admin");
  const isVolunteerAuthenticated = !!sessionStorage.getItem("volunteerData");

  if (isAdminAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isVolunteerAuthenticated) {
    return <Navigate to="/volunteer" replace />;
  }

  return <Navigate to="/login" replace />;
}

function App() {
  const [audioUnlocked, setAudioUnlocked] = useState(false);

  useEffect(() => {
    // If already unlocked previously, skip intro
    if (localStorage.getItem("audioUnlocked") === "true") {
      setAudioUnlocked(true);
    }
  }, []);

  return (
    <Router>
      <GlobalProvider>
        {/* Intro Screen Overlay */}
        {!audioUnlocked && (
          <IntroScreen onContinue={() => setAudioUnlocked(true)} />
        )}

        <Toaster position="top-center" toastOptions={{ duration: 5000 }} />

        <Routes>
          {/* PUBLIC ROUTES */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/volunteer/login" element={<VolunteerLoginPage />} />

          {/* ADMIN ROUTES */}
          <Route
            path="/"
            element={
              <AdminProtected>
                <MainLayout />
              </AdminProtected>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardContainer />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="teams" element={<TeamsPage />} />
            <Route path="driver" element={<DriversPage />} />
            <Route
              path="drivers/orders/:driverId"
              element={<DriverOrdersPage />}
            />
            <Route path="banks" element={<BankPage />} />
            <Route path="tasks" element={<TasksPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="shops" element={<ShopsPage />} />
            <Route path="slots" element={<SlotManager />} />
            <Route path="tiers" element={<TierSection />} />
            <Route path="notifications" element={<Notification />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="settlement" element={<Settlement />} />
            <Route path="store" element={<Store />} />

            <Route
              path="analytics/:driverId/:username"
              element={<DriverAnalytics />}
            />

            <Route
              path="settlement-detail/:driverId/:username"
              element={<SettlementDetail />}
            />
            <Route path="admin" element={<Admin />} />

            {/* Unknown admin route */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>

          {/* VOLUNTEER ROUTES - keep before admin root route */}
          <Route
            path="/volunteer"
            element={
              <VolunteerProtected>
                <VolunteerLayout />
              </VolunteerProtected>
            }
          >
            <Route index element={<VolunteerPage />} />
            <Route path="shops" element={<VolunteerShopsPage />} />
            <Route path="attendance" element={<VolunteerAttendance />} />
            <Route path="bank" element={<VolunteersBank />} />
            <Route path="settlement" element={<VolunteerSettlement />} />

            {/* Unknown volunteer route */}
            <Route path="*" element={<Navigate to="/volunteer" replace />} />
          </Route>

          {/* FINAL GLOBAL UNKNOWN ROUTE */}
          <Route path="*" element={<CatchAllRedirect />} />
        </Routes>
        {/* <Route path="/" element={<Navigate to="/login" replace />} /> */}
      </GlobalProvider>
    </Router>
  );
}

export default App;
